import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getTopper } from "../Service/Api.js";

function InnerTopperX() {
  const [toppers, setToppers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [search, setSearch] = useState("");

  const BASE_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

  const fallbackImg =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXCKWB/public/images/dummy.jpg";

  useEffect(() => {
    const fetchToppers = async () => {
      try {
        setLoading(true);
        const res = await getTopper();

        const data = Array.isArray(res) ? res : res?.data || [];

        const formatted = data
          .filter((item) => item.class === "X")
          .map((item) => {
            const rawDate = item.date || item.createdAt;
            const date = rawDate ? new Date(rawDate) : new Date();

            return {
              ...item,

              imageUrl: item.attachments?.length
                ? BASE_URL + item.attachments[0]
                : "",

              year: date.getFullYear().toString(),
              month: (date.getMonth() + 1).toString(),
            };
          });

        setToppers(formatted);

        const years = [...new Set(formatted.map((i) => i.year))].sort(
          (a, b) => b - a,
        );

        if (years.length > 0) setSelectedYear(years[0]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchToppers();
  }, []);

  const uniqueYears = useMemo(() => {
    return [...new Set(toppers.map((i) => i.year))].sort((a, b) => b - a);
  }, [toppers]);

  const filtered = useMemo(() => {
    return toppers
      .filter((item) => {
        const yearMatch = selectedYear === "All" || item.year === selectedYear;

        const monthMatch =
          selectedMonth === "All" || item.month === selectedMonth;

        const searchMatch = item.name
          ?.toLowerCase()
          .includes(search.toLowerCase());

        return yearMatch && monthMatch && searchMatch;
      })
      .sort((a, b) => {
        const percentageA = parseFloat(
          String(a.division || "").replace("%", ""),
        );

        const percentageB = parseFloat(
          String(b.division || "").replace("%", ""),
        );

        return percentageB - percentageA;
      });
  }, [toppers, selectedYear, selectedMonth, search]);

  if (loading) {
    return <h4 className="text-center py-5">Loading...</h4>;
  }

  return (
    <>
      <Header />
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Inner"
          title2="Topper-X"
          parentTitle="Toppers"
          path="Inner Toppers"
        />
      </div>

      <div className="innerbody">
        <div className="container-fluid">
          <div className="row tabs-dynamics mt-3">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3  col-md-3 col-12">
              <div className="filter-card count-card">
                <p>
                  Total Count <span>{filtered.length}</span>
                </p>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3  col-md-3 col-12">
              <div className="filter-card">
                <select
                  className="form-select"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="All">All Years</option>
                  {uniqueYears.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3  col-md-3 col-12">
              <div className="filter-card">
                <select
                  className="form-select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="All">All Months</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={(i + 1).toString()}>
                      {new Date(0, i).toLocaleString("en-US", {
                        month: "short",
                      })}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3  col-md-3 col-12">
              <div className="filter-card">
                <input
                  className="form-control"
                  placeholder="Search Topper..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {filtered.length > 0 ? (
              filtered.map((item, i) => (
                <div
                  key={item._id || i}
                  className="
                  col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12  mb-4"
                >
                  <div className="topper-card">
                    <img
                      src={item.imageUrl || fallbackImg}
                      alt={item.name || "topper"}
                      className="topper-img"
                    />

                    <div className="topper-body">
                      <h5>{item.name || "N/A"}</h5>
                      {item.class && <p>Class: {item.class}</p>}
                      {item.rank && <p>Rank: {item.rank}</p>}
                      {item.division && <p>Percentage: {item.division}</p>}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <h5>No Toppers Found</h5>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default InnerTopperX;
